import { useShow, useTranslate } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { BannerActionDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { buildCreativeModel } from '@/components/user_catalog/banner_actions/bannerActionPreview';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  BANNER_ACTION_DEFAULT_TAB,
  BANNER_ACTION_SHOW_TABS,
} from '../constants';
import { BannerActionShowHeader } from './BannerActionShowHeader';
import { BannerActionGeneralTab } from './BannerActionGeneralTab';

export const BannerActionShow = () => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const { query } = useShow<BannerActionDetailOut>({
    resource: 'user_catalog.banner_actions',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('user_catalog.banner_actions', record?.name);

  const [activeTab, onTabChange] = useShowTab(
    BANNER_ACTION_SHOW_TABS,
    BANNER_ACTION_DEFAULT_TAB
  );

  const model = record ? buildCreativeModel(record) : null;

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      title={t('user_catalog.banner_actions.titles.show')}
    >
      {record && model && (
        <>
          <BannerActionShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <BannerActionGeneralTab record={record} model={model} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
